export default __webpack_public_path__ + "media/alert.mp3";